import * as React from "react";
import "../../assets/scss/components/generic/slideUpPopup.scss";

export interface ISlideUpPopupProps {
	closePopup: () => void;
}

const SlideUpPopup: React.FC<ISlideUpPopupProps> = props => {
	return (
		<>
			<div className="slide_up_popup_overlay" onClick={props.closePopup}></div>
			<div className="slide_up_popup">{props.children}</div>
		</>
	);
};

export default SlideUpPopup;
